import axios from 'axios'

export default {
    getAll: () => axios.get(`/news_event`),
    getById: newsId => axios.get(`/news_event/${newsId}`),
    create: formData => axios.post(`/news_event/create`, formData),
    edit: formData => axios.put(`/news_event/edit`, formData),
    changeStatus: formData => axios.patch(`/news_event/toggle_status`, formData),
    delete: newsId => axios.delete(`/news_event/delete/${newsId}`)
}
